import Vue from "vue";
import * as Api from "../../api";

const state = {

}

const getters = {}

const mutations = {
}

const actions = {
  getAdvertisements({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/oa/advertising/getAdvertising`,
      ...params,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getAdvertisementsCallback");
      }
    });
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/advertisement.js